import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import styled from 'styled-components';
import { generateCode, verifyCode } from './util/generate-verify-code';
import { ConfirmCodeInput } from './ConfirmCodeInput';

const StyledCodeDiv = styled.div`
  display: flex;
  justify-content: center;
`;

const SignupConfirmDialog = (props) => {
  const { onClose, open, header } = props;
  const [generatedCode, setGeneratedCode] = useState('');
  const [confirmCode, setConfirmCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const newCode = generateCode();
    setGeneratedCode(newCode);
  }, []);

  const verify = () => {
    if (confirmCode.length === 0) {
      setErrorMessage('Please enter the Confirmation Code.');
    } else {
      const { variant, message } = verifyCode(confirmCode, generatedCode);
      onClose(variant, message);
    }
  };

  const handleOk = () => {
    if (confirmCode.length === 0) {
      setErrorMessage('Please enter the Confirmation Code.');
    } else {
      verify();
    }
  };

  const codeChange = (event) => {
    setErrorMessage('');
    setConfirmCode(event.target.value);
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      open={open}
    >
      <DialogTitle>{header}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          Enter {generatedCode} into Confirmation Code.
        </DialogContentText>
        <StyledCodeDiv>
          <ConfirmCodeInput
            maxLength={4}
            onChange={codeChange}
            value={confirmCode}
            onPressEnter={handleOk}
          />
        </StyledCodeDiv>
        <DialogContentText style={{ color: 'red' }}>
          {errorMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export { SignupConfirmDialog };
